

export const TYPES = {
    ALL: "ALL",
    REQUESTED: "REQUESTED",
    IRSEN: "IRSEN",
    CONFIRM: "CONFIRM",
    REJECTED: "REJECTED",
}

export const LEASING_TYPES = {
    N: "N",
    Y: "Y",
    R: "R",
}


export const PRICE_TYPE = {
    N: "N",
    Y: "Y",
}

export const CATEGORY = {
    CLOTHS: "CLOTHS",
    ONTSLOH: "ONTSLOH",
    GER: "GER",
    OTHER: "OTHER",
}


export const baseUrlLink = "https://skyhousebucket.s3.ap-southeast-1.amazonaws.com//upload/image-"